import type { MonoTypeOperatorFunction, Observable, Subscription } from 'rxjs';

interface EmergencyCallDetailsEventSubscription {
  event$: Observable<unknown>;
  handler: () => void;
}

type WhileComponentMounted = <T>() => MonoTypeOperatorFunction<T>;

export const subscribeToEmergencyCallDetailsEvents = (
  subscriptions: EmergencyCallDetailsEventSubscription[],
  whileComponentMounted: WhileComponentMounted
): Subscription[] =>
  subscriptions.map(({ event$, handler }) =>
    event$.pipe(whileComponentMounted()).subscribe(handler)
  );
